/* tslint:disable */

declare var Object: any;
export interface CountryInterface {
  createdby?: string;
  lastupdatedby?: string;
  id?: any;
  createdAt: Date;
  updatedAt: Date;
}

export class Country implements CountryInterface {
  createdby: string;
  lastupdatedby: string;
  id: any;
  createdAt: Date;
  updatedAt: Date;
  constructor(data?: CountryInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Country`.
   */
  public static getModelName() {
    return "Country";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Country for dynamic purposes.
  **/
  public static factory(data: CountryInterface): Country{
    return new Country(data);
  }  
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Country',
      plural: 'countries',
      properties: {
        createdby: {
          name: 'createdby',
          type: 'string',
          default: 'system'
        },
        lastupdatedby: {
          name: 'lastupdatedby',
          type: 'string',
          default: 'system'
        },
        id: {
          name: 'id',
          type: 'any'
        },
        createdAt: {
          name: 'createdAt',
          type: 'Date'
        },
        updatedAt: {
          name: 'updatedAt',
          type: 'Date'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/sdk/models/Country.ts